import Cookies from 'js-cookie';

const MeViewType = 'Gw-MeViewType';

const user = {
  state: {
    get token() {
      return Cookies.get('Token');
    },
    get userId() {
      return Cookies.get('UserID');
    },
    get openId() {
      return Cookies.get('OpenID');
    },
    get nickName(){
      return Cookies.get('NickName');
    },
    get fullName() {
      return Cookies.get('FullName');
    },
    get headImage() {
      return Cookies.get('HeadImage');
    },
    get mobile() {
      return Cookies.get('Mobile');
    },
    get roleId() {
      return Cookies.get('RoleID');
    },
    get introduceCode() {
      return Cookies.get('IntroduceCode');
    },
    get couponCode() {
      return Cookies.get('CouponCode');
    },
    get defaultRole(){
      return Cookies.get('DefaultRole');
    },
    get meState(){
      return Cookies.get('MeState');
    },
    get hrName(){
      return Cookies.get('HrName');
    },
    get hrState(){
      return Cookies.get('HrState');
    },
    get meViewType() {
      return localStorage.getItem(MeViewType);
    },
  },
  mutations: {
    setToken (state, token) {
      Cookies.set('Token', token);
    },
    setUserId (state, userId){
      Cookies.set('UserID', userId);
    },
    setOpenId (state, openId){
      Cookies.set('OpenID', openId);
    },
    setNickName(state, nickName){
      Cookies.set('NickName', nickName);
    },
    setFullName(state, fullName){
      Cookies.set('FullName', fullName);
    },
    setHeadImage(state, headImage){
      Cookies.set('HeadImage', headImage);
    },
    setMobile(state, mobile){
      Cookies.set('Mobile', mobile);
    },
    setRoleID (state, roleId){
      Cookies.set('RoleID', roleId);
    },
    setIntroduceCode (state, code){
      Cookies.set('IntroduceCode', code);
    },
    setCouponCode (state, code){
      Cookies.set('CouponCode', code);
    },
    setDefaultRole(state, roleId){
      Cookies.set('DefaultRole', roleId);
    },
    setMeState(state, meState){
      Cookies.set('MeState', meState);
    },
    setHrName(state, hrName){
      Cookies.set('HrName', hrName);
    },
    setHrState(state, hrState){
      Cookies.set('HrState', hrState);
    },
    SET_ME_VIEW_TYPE: (state, viewType) => {
      localStorage.setItem(MeViewType, viewType);
    },
  },
  actions:{
    Login({ commit }, userInfo){
      commit('setToken', userInfo.token);
      commit('setUserId', userInfo.user_id);
      commit('setNickName', userInfo.nick_name);
      commit('setHeadImage', userInfo.head_image);
      commit('setMobile', userInfo.mobile);    
      commit('setRoleID', userInfo.user_role); 
    },
    MeLogin({ commit }, meInfo){
      commit('setFullName', meInfo.full_name);
      commit('setMeState', meInfo.me_state);
    },
    HrLogin({ commit }, hrInfo){
      commit('setHrName', hrInfo.hr_name);
      commit('setHrState', hrInfo.hr_state);
    },
    Logout({ commit }){
      commit('setToken', '');
      commit('setUserId', '');
      commit('setNickName', '');
      commit('setFullName', '');
      commit('setHeadImage', '');
      commit('setMobile', '');
      commit('setMeState', '');
      commit('setRoleID', '');
      commit('setOpenId', '');
      commit('setHrName', '');
      commit('setHrState', '');
    }
  }
};

export default user;